(function () {
  function renderAlpineComponent() {
    Alpine.data("pdpV4Gallery", () => ({
      isGalleryModalOpen: false,
      galleryMedia: [],
      currentSlideIndex: 0,
      currentMedia: null,
      mainSwiper: null,
      thumbSwiper: null,

      init() {
        // Parse media data from JSON script tag for Ajax compatibility
        this.loadMediaData();

        // Listen for keyboard navigation
        document.addEventListener("keydown", this.handleKeyNavigation.bind(this));
        window.addEventListener("variant_color_updated", () => {
          this.loadMediaData();
        });
      },

      loadMediaData() {
        try {
          const dataScript = this.$el.querySelector("#pdp-v4-gallery-data");
          if (dataScript) {
            const data = JSON.parse(dataScript.textContent);
            this.galleryMedia = data.media || [];
          }
        } catch (error) {
          console.error("Failed to load gallery media data:", error);
          this.galleryMedia = [];
        }
      },

      openGalleryModal(startIndex = 0) {
        if (this.galleryMedia.length === 0) {
          this.loadMediaData(); // Retry loading if data is missing
        }

        if (this.galleryMedia.length > 0) {
          this.currentSlideIndex = Math.max(0, Math.min(startIndex, this.galleryMedia.length - 1));
          this.updateCurrentMedia();
          this.isGalleryModalOpen = true;

          // Prevent body scroll when modal is open
          document.body.style.overflow = "hidden";

          // Initialize Swiper after modal is opened
          this.$nextTick(() => {
            this.initializeSwipers();
            this.handleVideoAutoplay();
          });
        }
      },

      closeGalleryModal() {
        this.isGalleryModalOpen = false;

        // Re-enable body scroll
        document.body.style.overflow = "";

        // Stop all video/audio playback and cleanup
        this.stopAllMediaPlayback();

        // Destroy Swiper instances
        this.destroySwipers();

        // Reset current media
        this.currentMedia = null;
      },

      initializeSwipers() {
        // Destroy existing instances if they exist
        this.destroySwipers();

        // Initialize main gallery swiper
        if (this.$refs.mainSwiper && window.Swiper) {
          this.mainSwiper = new Swiper(this.$refs.mainSwiper, {
            slidesPerView: 1,
            spaceBetween: 10,
            initialSlide: this.currentSlideIndex,
            navigation: false, // Using custom navigation buttons
            on: {
              slideChange: (swiper) => {
                this.currentSlideIndex = swiper.activeIndex;
                this.updateCurrentMedia();

                // Sync thumbnail swiper
                if (this.thumbSwiper) {
                  this.thumbSwiper.slideTo(swiper.activeIndex);
                }

                // Manage video playback when changing slides
                this.$nextTick(() => {
                  this.handleVideoAutoplay();
                });
              },
            },
          });
        }

        // Initialize thumbnail swiper
        if (this.$refs.thumbSwiper && window.Swiper) {
          this.thumbSwiper = new Swiper(this.$refs.thumbSwiper, {
            slidesPerView: "auto",
            spaceBetween: 10,
            centeredSlides: false,
            initialSlide: this.currentSlideIndex,
            watchSlidesProgress: true,
            freeMode: true,
          });
        }
      },

      destroySwipers() {
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
          this.mainSwiper = null;
        }
        if (this.thumbSwiper) {
          this.thumbSwiper.destroy(true, true);
          this.thumbSwiper = null;
        }
      },

      goToSlide(index) {
        if (index >= 0 && index < this.galleryMedia.length) {
          this.currentSlideIndex = index;
          this.updateCurrentMedia();

          // Use Swiper to navigate if available
          if (this.mainSwiper) {
            this.mainSwiper.slideTo(index);
          }
          if (this.thumbSwiper) {
            this.thumbSwiper.slideTo(index);
          }
        }
      },

      nextSlide() {
        if (this.mainSwiper) {
          this.mainSwiper.slideNext();
        } else {
          const nextIndex = this.currentSlideIndex + 1;
          if (nextIndex < this.galleryMedia.length) {
            this.goToSlide(nextIndex);
          } else {
            this.goToSlide(0); // Loop to first
          }
        }
      },

      prevSlide() {
        if (this.mainSwiper) {
          this.mainSwiper.slidePrev();
        } else {
          const prevIndex = this.currentSlideIndex - 1;
          if (prevIndex >= 0) {
            this.goToSlide(prevIndex);
          } else {
            this.goToSlide(this.galleryMedia.length - 1); // Loop to last
          }
        }
      },

      updateCurrentMedia() {
        if (this.galleryMedia[this.currentSlideIndex]) {
          this.currentMedia = this.galleryMedia[this.currentSlideIndex];
        }
      },

      handleVideoAutoplay() {
        // First, pause all videos
        this.pauseAllVideos();

        // Then play the current video if it's a video slide
        if (this.currentMedia?.type === "video") {
          // Wait a bit for the slide transition to complete
          setTimeout(() => {
            const activeSlide = this.$refs.mainSwiper?.querySelector(".swiper-slide-active");
            const videoElement = activeSlide?.querySelector("video");
            if (videoElement) {
              videoElement.play().catch((error) => {
                console.log("Video autoplay failed:", error);
              });
            }
          }, 100);
        }
      },

      pauseAllVideos() {
        // Pause all video elements in the modal
        if (this.$refs.mainSwiper) {
          const videos = this.$refs.mainSwiper.querySelectorAll("video");
          videos.forEach((video) => {
            if (!video.paused) {
              video.pause();
            }
          });
        }
      },

      stopAllMediaPlayback() {
        // Stop all video elements
        if (this.$refs.mainSwiper) {
          const videos = this.$refs.mainSwiper.querySelectorAll("video");
          videos.forEach((video) => {
            video.pause();
            video.currentTime = 0;
          });

          // Stop all iframe videos (external videos)
          const iframes = this.$refs.mainSwiper.querySelectorAll("iframe");
          iframes.forEach((iframe) => {
            // Reset iframe src to stop playback
            const src = iframe.src;
            iframe.src = "";
            iframe.src = src;
          });
        }
      },

      handleEscape(event) {
        if (event.key === "Escape" && this.isGalleryModalOpen) {
          this.closeGalleryModal();
        }
      },

      handleKeyNavigation(event) {
        if (!this.isGalleryModalOpen) return;

        switch (event.key) {
          case "ArrowLeft":
            event.preventDefault();
            this.prevSlide();
            break;
          case "ArrowRight":
            event.preventDefault();
            this.nextSlide();
            break;
          case "Escape":
            event.preventDefault();
            this.closeGalleryModal();
            break;
        }
      },

      destroy() {
        // Clean up event listeners
        document.removeEventListener("keydown", this.handleEscape.bind(this));
        document.removeEventListener("keydown", this.handleKeyNavigation.bind(this));

        // Destroy Swiper instances
        this.destroySwipers();

        // Stop any playing media
        this.stopAllMediaPlayback();
      },
    }));
  }

  document.addEventListener("alpine:init", renderAlpineComponent);

  if (!window.Alpine) return;
  renderAlpineComponent();
})();
